var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.Datasource)+" "),_c('e-charts',{ref:"bar",attrs:{"autoresize":"","options":_vm.bar,"theme":"ovilia-green","auto-resize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }